import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {EmploymentType} from "../../../agents/types/employment.type";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class RouteAssignAgentDialogViewCtrl implements IController {
  serviceIds: any;
  highPriorityAgentsIds: string[];
  linkedAgentId: string;
  onAssign: Function;

  public assignRelatedChecked: boolean;
  public assignableServices: any;
  public unAssignableServices: any;
  public doForce: boolean;
  public services: any[];
  public employmentType: string;
  public settings: any;
  private employmentTypes: string[];


  private deliveriesRef: any;
  private queryString: any;
  // private unpackedDeliveryIds: any;
  private profileAccountId: any;
  private queryTypes: any;
  private selectedQueryType: any;
  private selectedAgentStatus: any;
  private assignData: any;
  private isXsScreen: boolean;



  /* @ngInject */
  constructor(private $delivery, private deliveriesRequestsService: DeliveriesRequestsService, private deliveriesService: DeliveriesService, private $accounts: $accountsFactory,
              private agentsAlerts: AgentsAlerts, private $log, private $mdMedia,  private splitService: SplitService) {
    this.deliveriesRef = this.$delivery();
  }

  $onInit() {
    this.assignableServices = [];
    this.unAssignableServices = [];
    this.assignRelatedChecked = true;
    this.employmentTypes = ['All', EmploymentType.Payroll, EmploymentType.Independent];
    this.employmentType = 'All'

    this.settings = this.splitService.getSiteServicesAssignAgentSettings();

    this.queryTypes = {
      Location: 'Driver location',
      OptimizedRoute: 'Optimized driver route',
      AgentRoute: 'Driver scoring'
    };
    this.selectedQueryType = {
      key: 'Location',
      value: 'Driver location'
    };

    if (this.serviceIds && this.serviceIds.length) {
      this._setAssignData()
    }

  }

  $doCheck() {
    this.isXsScreen = !this.$mdMedia('gt-xs');
  };

  $onChanges(changes) {
    if (changes.serviceIds && !changes.serviceIds.isFirstChange()) {
      this.$onInit();
    }
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  // onSelectAgentStatus(status) {
  //   this.selectedAgentStatus = status;
  //   this._setAssignData();
  // }

  onQueryStringChange(queryString) {
    this.queryString = queryString;
  }

  onFilter(queryString) {
    return (item) => {
      return ((this.employmentType === 'All' || item.agent.employmentType === this.employmentType) &&
        (!queryString
          || (item.agent.user.firstName?.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
          || (item.agent.user.lastName?.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
          || (item.agent.user.mobilePhone?.indexOf(queryString.toLowerCase()) !== -1)));
    }
  }

  onSelectQueryType(typeKey, typeValue) {
    this.selectedQueryType = {
      key: typeKey,
      value: typeValue
    };
    this._setAssignData();
  }

  onAssignServicesToggled() {
    this.assignRelatedChecked = !this.assignRelatedChecked;
    this._setAssignData()
  }

  onAssignAgent(agent) {
    const relatedServicesIds = _.map(this.assignableServices, (s) => {
      return s.id
    })

    this.onAssign({
      agent,
      relatedServicesIds: this.assignRelatedChecked ? relatedServicesIds : [],
      doForce: this.doForce
    })
  }

  setEvents() {
    const div1 = document.getElementById('route-assign-agent-dialog').querySelectorAll("#route-assign-agent-dialog-header")[0];
    const div2 = document.getElementById('route-assign-agent-dialog').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  onViewSettingsChange(settings) {
    this.settings = settings;
    this.splitService.setSiteServicesAssignAgentSettings(settings);
  }

  // ******************************
  //        Private methods
  // ******************************
  private _setAssignData() {

    let group = this._getGroup(),
      status = this._getStatus();

    this.assignData = undefined;
    // this.unpackedDeliveryIds = undefined;


    return this.deliveriesRef.$asyncValues(this.serviceIds)
      .then((services) => {
        this.services = services;
        if (!this.assignRelatedChecked) {
          return [];
        }
        const relatedServiceIds = this.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
        if (relatedServiceIds.length) {
          return this.deliveriesRef.$asyncValues(relatedServiceIds)
        }

      })
      .then((relatedService) => {
        let totalServices = this.serviceIds;
        if (!relatedService) {
          this.assignRelatedChecked = false;
        }

        if (this.assignRelatedChecked && relatedService) {
          this._setRelations(relatedService);
          const assignableServicesIds = _.map(this.assignableServices, (as: any) => {
            return as.id;
          })

          // for the totals
          this.services = _.concat(this.services, this.assignableServices);
          totalServices = _.union(this.serviceIds, assignableServicesIds);
        }

        return this.deliveriesRequestsService.getAssignAgentData(totalServices, this.selectedQueryType.key, this.queryString, group, status)
      })
      .then((data) => {
        this.assignData = data;
        // this._setUnpackedDeliveries(services);
        if (_.isEqual(this.selectedQueryType.key, 'AgentRoute') && _.get(this.assignData, 'list.length')) {
          this.profileAccountId = _.get(this.assignData, 'list[0].accountIdForConfigProfile');
        }

        this._setPriorityAgentsFirst(this.highPriorityAgentsIds);
      })
      .catch((error) => {
        this.agentsAlerts.getManyError();
        this.$log.error('Failed to get assign data ' +
          '@servicesAssignDialogView@_setAssignData', error);
      })
  }

  private _setRelations(relatedServices: any): void {

    const assignableServices = relatedServices.filter((relatedService) => {
      return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
    });

    const unAssignableServices = _.differenceBy(relatedServices, this.assignableServices);

    // relatedServices entities may be shared, frozen references (e.g. from the NgRx store),
    // so clone them before ng-repeat tries to stamp a $$hashKey onto them.
    this.assignableServices = angular.copy(assignableServices);
    this.unAssignableServices = angular.copy(unAssignableServices);
  }

  private _setPriorityAgentsFirst(highPriorityAgentsIds) {
    if (!_.get(highPriorityAgentsIds, 'length')) return;

    const priorityAgentsList = []
    _.forEach(highPriorityAgentsIds, (pai) => {
      const agent = _.find(this.assignData.list, (agent) => {
        return agent.agentId === pai;
      })
      if (agent) {
        priorityAgentsList.push(agent);
      }
    });

    //remove found priority agents from main list
    _.forEach(priorityAgentsList, (pa) => {
      {
        _.remove(this.assignData.list, (agent: any) => {
          return agent.agentId === pa.agentId;
        })
      }
    })
    this.assignData.list = _.concat(priorityAgentsList, this.assignData.list);

  }

  private _getGroup() {
    return this.selectedAgentStatus === 'Active' ? 'Active' : undefined;
  }

  private _getStatus() {
    return this.selectedAgentStatus === 'OffDuty' ? 'OffDuty' : undefined;
  }
}

angular
  .module(
    'bringoz.admin.lean-planning'
  )
  .component('routeAssignAgentDialogView', {
      bindings: {
        serviceIds: '<',
        highPriorityAgentsIds: '<?',
        linkedAgentId: '<?',
        onAssign: '&',
      },
      template: require('./route-assign-agent-dialog-view.html').default,
      controller: RouteAssignAgentDialogViewCtrl
    }
  );
